// Tiny helpers for the auth-aware shell. Kept out of api.ts so that the
// dynamic import from src/shared/messages.ts can put dispatchMsg in its
// own chunk without dragging in this UI-only code.

const API_BASE = '/api';

export async function getMe(): Promise<{ id: string; email: string; is_admin?: boolean } | null> {
  try {
    const r = await fetch(API_BASE + '/me', { credentials: 'include' });
    if (r.status === 401) return null;
    if (!r.ok) return null;
    return await r.json();
  } catch {
    return null;
  }
}

export async function logout(): Promise<void> {
  await fetch(API_BASE + '/auth/logout', { method: 'POST', credentials: 'include' });
}
